import { createMuiTheme, makeStyles } from "@material-ui/core/styles";

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#4caf50',
    },
    secondary: {
      main: '#4caf50',
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        color: '#4caf50',
      },
      active: {
        color: '#4caf50',
      },
      completed: {
        color: '#4caf50',
      },
    },
    MuiOutlinedInput: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#4caf50',
        },
      },
    },
    MuiButton: {
      containedPrimary: {
        backgroundColor: '#4caf50',
        '&:hover': {
          backgroundColor: '#43a047',
        },
      },
    },
  },
});

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    maxWidth: 600,
    margin: '0 auto',
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      maxWidth: '100%',
      margin: 0,
      padding: theme.spacing(1),
    },
  },
  buttonRow: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'end',
  },
}));